import { Injectable } from '@angular/core';
import {ConfigurationDataService} from '../configuration-data.service';
import {SharedDataService} from '../shared-data.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import {BinType} from './bintype';

@Injectable()
export class BinTypeService {

  headers = new HttpHeaders({
      'Content-Type': 'application/json'
  });

  constructor(public http: HttpClient, private config : ConfigurationDataService, private shared: SharedDataService) {
  }

  /**
   * List all bintypes which belong to loggedin user.
   */
  public list() {
    console.log(JSON.stringify(this.shared.getTokenAuthData()));
    return this.http.post(this.config.bintypeURL+"list", JSON.stringify(this.shared.getTokenAuthData()), {headers: this.headers});
  }

  public save(bintype : BinType) {
    console.log('Push bintype to insert method of service.');
    bintype.credentials = this.shared.getTokenAuthData();
    console.log(JSON.stringify(bintype));
    return this.http.post(this.config.bintypeURL+"new", JSON.stringify(bintype), {headers: this.headers});
  }

  public update(bintype : BinType) {
    console.log('Push bintype to update method of service.');
    bintype.credentials = this.shared.getTokenAuthData();
    console.log(JSON.stringify(bintype));
    return this.http.put(this.config.bintypeURL+"id/"+bintype.id, JSON.stringify(bintype), {headers: this.headers});

  }

  public qryBinType(id : number) {
    return this.http.post(this.config.bintypeURL+"id/"+id, 
    JSON.stringify(this.shared.getTokenAuthData()), {headers: this.headers});

  }

  public delete(id : number) {
    console.log('Delete bintype '+ id);
    return this.http.post(this.config.bintypeURL+"del/"+id, 
    JSON.stringify(this.shared.getTokenAuthData()), {headers: this.headers});

  }
}



// WEBPACK FOOTER //
// /home/pneuser/workspace/pepelogistic/pepeLogisticControl/src/app/location/bin-type.service.ts